import { useTranslation } from "react-i18next"
import { useContext, useEffect, useState } from "react"
import { AccountContext } from "../contexts/AccountContexts"
import { requestFaqs } from "../requests/setup_requests"
import { PageHeader } from "../components/HeaderComponents"
import { loadingActive, PageLoadingScreen, SplitScreenBackground } from "../components/Background"
import NavBar from "../components/NavBar"
import { GuestFooter } from "../components/FooterComponents"


export const FAQPage = () => {
    const { t } = useTranslation("common")
    const { language } = useContext(AccountContext)

    const [faqs, setFaqs] = useState([])


    useEffect(() => {
        loadingActive(true)
        requestFaqs({})
            .then((data) => {
                setFaqs(data.faqs)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
            .finally(() => {
                loadingActive(false)
            })
    }, [])

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return (
        <>
            <SplitScreenBackground />
            <div className="flex flex-col items-center justify-start  gap-5 pt-2 relative h-full">
                <PageHeader pageTitle={t("FAQ")} />
                <NavBar />
                <PageLoadingScreen />
                <div className="flex flex-col items-center w-full mx-auto max-w-[1200px] min-h-screen bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 rounded-xl shadow-sm pb-12 py-5 px-3 sm:p-5 gap-4">
                    <span className="text-blue-900 dark:text-blue-500 font-semibold text-xl">{t("Frequently Asked Questions")}</span>

                    <div className="hidden sm:flex gap-3">

                        <div className="flex flex-col gap-3">
                            {
                                faqs.map((faq, index) =>
                                    index % 2 == 0 &&
                                    <div key={faq.id} className="collapse collapse-plus max-w-[500px] bg-gray-100 dark:bg-gray-800">
                                        <input type="checkbox" />
                                        <div className="collapse-title text-md font-medium">{language === "tr" ? faq.title : faq.engTitle}</div>
                                        <div className="collapse-content text-sm whitespace-pre-wrap text-wrap">
                                            {/* <span>{language === "tr" ? faq.message : faq.engMessage}</span> */}
                                            {
                                                language === "tr" ?
                                                    faq.message.split(urlRegex).map((part, index) =>
                                                        urlRegex.test(part) ? (
                                                            <a
                                                                key={index}
                                                                href={part}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-blue-500 hover:underline"
                                                            >
                                                                {part}
                                                            </a>
                                                        ) : (
                                                            <span key={index}>{part}</span>
                                                        )
                                                    )
                                                    :
                                                    faq.engMessage.split(urlRegex).map((part, index) =>
                                                        urlRegex.test(part) ? (
                                                            <a
                                                                key={index}
                                                                href={part}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-blue-500 hover:underline"
                                                            >
                                                                {part}
                                                            </a>
                                                        ) : (
                                                            <span key={index}>{part}</span>
                                                        )
                                                    )
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="flex flex-col gap-3">
                            {
                                faqs.map((faq, index) =>
                                    index % 2 == 1 &&
                                    <div key={faq.id} className="collapse collapse-plus max-w-[500px] bg-gray-100 dark:bg-gray-800">
                                        <input type="checkbox" />
                                        <div className="collapse-title text-md font-medium">{language === "tr" ? faq.title : faq.engTitle}</div>
                                        <div className="collapse-content text-sm whitespace-pre-wrap text-wrap">
                                            {
                                                language === "tr" ?
                                                    faq.message.split(urlRegex).map((part, index) =>
                                                        urlRegex.test(part) ? (
                                                            <a
                                                                key={index}
                                                                href={part}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-blue-500 hover:underline"
                                                            >
                                                                {part}
                                                            </a>
                                                        ) : (
                                                            <span key={index}>{part}</span>
                                                        )
                                                    )
                                                    :
                                                    faq.engMessage.split(urlRegex).map((part, index) =>
                                                        urlRegex.test(part) ? (
                                                            <a
                                                                key={index}
                                                                href={part}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-blue-500 hover:underline"
                                                            >
                                                                {part}
                                                            </a>
                                                        ) : (
                                                            <span key={index}>{part}</span>
                                                        )
                                                    )
                                            }
                                        </div>
                                    </div>

                                )
                            }
                        </div>
                    </div>

                    <div className="flex flex-col gap-3 sm:hidden">
                        {
                            faqs.map((faq, index) =>
                                <div key={faq.id} className="collapse collapse-plus max-w-[500px] bg-gray-100 dark:bg-gray-800">
                                    <input type="checkbox" />
                                    <div className="collapse-title text-md font-medium">{language === "tr" ? faq.title : faq.engTitle}</div>
                                    <div className="collapse-content text-sm whitespace-pre-wrap text-wrap">
                                        {/* <span>{language === "tr" ? faq.message : faq.engMessage}</span> */}
                                        {
                                            language === "tr" ?
                                                faq.message.split(urlRegex).map((part, index) =>
                                                    urlRegex.test(part) ? (
                                                        <a
                                                            key={index}
                                                            href={part}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-500 hover:underline"
                                                        >
                                                            {part}
                                                        </a>
                                                    ) : (
                                                        <span key={index}>{part}</span>
                                                    )
                                                )
                                                :
                                                faq.engMessage.split(urlRegex).map((part, index) =>
                                                    urlRegex.test(part) ? (
                                                        <a
                                                            key={index}
                                                            href={part}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-500 hover:underline"
                                                        >
                                                            {part}
                                                        </a>
                                                    ) : (
                                                        <span key={index}>{part}</span>
                                                    )
                                                )
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className="self-end mt-auto flex w-full bg-gray-100 dark:bg-gray-700">
                    <GuestFooter />
                </div>
            </div>
        </>
    )
}